import { ErrorResponse } from './../../../models/error.model';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { RecaptchaComponent } from 'ng-recaptcha';
import { SpinnerVisibilityService } from 'ng-http-loader';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public environment = environment;
    public showingPage: 'username' | 'password' = 'username';
    captchaKey = environment.captchaKey;

    private returnUrl: string;
    error?: string;

    public usernameFG = new UntypedFormGroup({
        username: new UntypedFormControl('', [Validators.required]),
    });

    public passwordFG = new UntypedFormGroup({
        password: new UntypedFormControl('', [Validators.required])
    });

    @ViewChild('captchaRef', { static: false })
    captchaRef: RecaptchaComponent;

    constructor(
        private changeDetector: ChangeDetectorRef,
        private authService: AuthService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute,
        private spinner: SpinnerVisibilityService
    ) { }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            if (params.returnUrl) {
                this.returnUrl = params.returnUrl;
            }
        });
    }

    showPassword() {
        this.showingPage = 'password';
        this.changeDetector.detectChanges();
        document.getElementById('passwordInput').focus();
    }

    showUsername() {
        this.showingPage = 'username';
        this.passwordFG.reset();
        this.changeDetector.detectChanges();
        document.getElementById('usernameInput').focus();
    }

    login() {
        if (this.usernameFG.valid && this.passwordFG.valid) {
            if (this.captchaKey) {
                this.captchaRef.reset();
                this.captchaRef.execute();
                this.spinner.show();
            } else {
                this.resolvedCaptcha();
            }
        }
    }

    onRecaptchaError() {
        this.spinner.hide();
    }

    resolvedCaptcha(captchaToken?: string) {
        this.error = undefined;
        this.spinner.hide();
        this.authService.logout();
        this.authService.login(this.usernameFG.value.username, this.passwordFG.value.password, captchaToken)
            .subscribe(
                session => {
                    if (session.token)
                        this.authService.saveToken(session.token);
                    if (session.usuario)
                        this.authService.saveUser(session.usuario);
                    if (this.returnUrl) {
                        this.router.navigate([this.returnUrl]);
                    } else {
                        this.router.navigate(['']);
                    }
                },
                (error: ErrorResponse) => {
                    if (error.error?.codigo === 'login.error') {
                        this.error = error.error?.descripcion;
                    } else {
                        this.utilsService.alert('Error iniciando sesión', error.error?.descripcion);
                    }
                }
            );
    }
}
